<template>
  <div id="app">
    
    <router-view></router-view>

    <!-- Side Navigation -->
    <div id="slide-out" class="sidenav">

      <div class="close-btn sidenav-close">
        <i class="xi-close"></i> 
      </div>

      <h2>My Resume</h2>

      <div class="divider"></div>

      <div class="gnb">
        <ul>
          <li>
            <router-link to="/home">
              <i class="xi-home"></i> HOME
            </router-link>
          </li>
          <li>
            <router-link to="/about">
              <i class="xi-user"></i> ABOUT
            </router-link>
          </li>
          <li>
            <router-link to="works">
              <i class="xi-camera"></i> WORKS
            </router-link>
          </li>
          <li>
            <router-link to="whatido">
              <i class="xi-telegram"></i> WHATIDO
            </router-link>
          </li>
          <li>
            <router-link to="/contact">
              <i class="xi-mail"></i> CONTACT
            </router-link>
          </li>
        </ul>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    this.sideNavi();
  },
  methods: {
    sideNavi(){
      $('.sidenav').sidenav({
        edge: 'right'
      });
    }
  }
}
</script>

<style lang="scss">

@import './sass/main.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue